import { Link, generatePath } from 'react-router-dom';
import { useClinicianPatientMenuInfo } from './useClinicianPatientMenuInfo';

export function PatientLink(props: { to: string; text: string }) {
  const match = useClinicianPatientMenuInfo();

  if (!match.isMenuEnabled) return <Link to="/">{props.text}</Link>;

  const route = generatePath(props.to, match.match?.params);

  return <Link to={route}>{props.text}</Link>;
}
